import { useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Whether the router has changed location since this document loaded.
 */
export const useIsClientNavigation = () => {
  const { key } = useLocation();
  const seen = useRef({ key, navigated: false });

  if (seen.current.key !== key) {
    seen.current = { key, navigated: true };
  }

  return seen.current.navigated;
};
